export default __webpack_public_path__ + "static/media/63.0ecf3ffc.jpg";